export function processUrl(rawUrl: string): string {
  let _url = rawUrl.trim();
  _url = /^https?:\/\//.test(_url) ? _url : `https://${_url}`;

  const url = new URL(_url);
  return url.origin + (url.pathname === "/" ? "" : url.pathname);
}
